import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { apiFetch } from "../utils/api";
import getImageUrl from "../utils/getImageUrl";

export default function FullArticle() {
  const { id } = useParams();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const fetchArticle = async () => {
      try {
        const res = await apiFetch(`/articles/${id}`);

        if (!res.ok) {
          throw new Error("Article not found");
        }

        const data = await res.json();
        if (isMounted) {
          setArticle(data);
        }
      } catch (err) {
        console.error(err);
        if (isMounted) {
          setArticle(null);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchArticle();

    return () => {
      isMounted = false;
    };
  }, [id]);

  if (loading) return <p className="loading">Loading...</p>;
  if (!article) return <p>Article not found.</p>;

  return (
    <div className="full-article-page">
      {/* Sticky Back Control */}
      <Link to="/" className="back-link sticky-back-link">
        <span className="back-arrow">←</span>
        <span className="back-text full">Back to News</span>
      </Link>

      <div className="full-article">
        <div className="full-article-container">
          {article.image && (
            <div className="full-article-image-wrapper">
              <img
                src={getImageUrl(article.image)}
                alt={article.title}
                className="full-article-image"
              />
            </div>
          )}

          <div className="full-article-content">
            <h1>{article.title}</h1>
            <p className="byline">
              By {article.author} •{" "}
              {new Date(article.created_at).toLocaleDateString()}
            </p>
            <p className="category-tag">{article.category}</p>
          </div>
        </div>

        {/* Full width text below image */}
        <div className="full-width-text">
          <p className="description">{article.description}</p>
        </div>
      </div>
    </div>
  );
}
